import React, { useEffect, useContext, useState } from "react";
import { useTable, useSortBy } from "react-table";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";

export const Table = ({ columns, data, timesheetAtividades,
    openModalItemAtividadeTimesheetHistoricoIsOpen,
    openEditModal,
    openCancelModal,
    openNotifyModal,
    openNotifyHistoricoModal,
    canEdit
}) => {

    const [atividades, setAtividades] = useState([]);

    const getAtividadesList = (timesheetAtividade) => {

        let valoresAtividadesAttr = [];


        const convertDecimalToTime = (decValue) => {
            if (!decValue) {
                return;
            }

            const decimalHours = parseFloat(decValue?.replace(',', '.'));
            const hours = Math.floor(decimalHours);
            const minutes = Math.round((decimalHours - hours) * 60);
            const formattedHours = String(hours).padStart(2, '0');
            const formattedMinutes = String(minutes).padStart(2, '0');

            return `${formattedHours}:${formattedMinutes}`;
        }


        if (!!timesheetAtividade) {

            timesheetAtividade.itens.map((item, index) => {
                valoresAtividadesAttr.push({
                    "idTimesheetItemAtividade": item.idTimesheetItemAtividade,
                    "data": item.datalancamento,
                    "perito": item.peritoNome,
                    "atividades": item.atividade,
                    "observacoes": item.descricao,
                    "inicio": item.periodoInicio,
                    "termino": item.periodoFim,
                    "intervalo": convertDecimalToTime(item.intervaloHoras),
                    "horas": item.baseHoras,
                    "valorhora": <span className="table-value">{item.valorHoraBase}</span>,
                    "total": <span className="table-nowrap">{item.totalValorFaturado}</span>,
                    "status": item.status,
                    "actions": item.actions,
                    "proBono": item.proBono,
                    "nameClass": item.actions.nameClass,
                    "acoes": <div style={{ width: "130px" }}>
                        {item.actions.detalhes ? <i className="fa fa-file-text-o table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openModalItemAtividadeTimesheetHistoricoIsOpen(item)} title="Histórico"></i> : ''} &nbsp;
                        {(item.actions.notificado || item.actions.editar && canEdit) && item.status != 'Cancelado' ? <i className="fa fa-pencil table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openEditModal(item)} title="Editar"></i> : ''} &nbsp;
                        {item.actions.cancelar && canEdit && item.status != 'Cancelado' ? <i className="fa fa-times table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openCancelModal(item.idTimesheetItemAtividade)} title="Cancelar"></i> : ''} &nbsp;
                        {item.actions.notificar && item.status != 'Cancelado' ? <i className="fa fa-commenting table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openNotifyModal(item.idTimesheetItemAtividade)} title="Notificar"></i> : ''} &nbsp;
                        {item.status != 'Cancelado' ? <i className="fa fa-bell table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openNotifyHistoricoModal(item)} title="Notificações"></i> : ''} &nbsp;
                        {/* { item.actions.ajustarTimer ? <i className="fa fa-clock-o table-color-button" aria-hidden="true" onClick={openTimerModal}></i> : <i className="fa fa-clock-o" aria-hidden="true"></i> } &nbsp;
                                { item.actions.faturamento ? <i className="fa fa-usd table-color-button" aria-hidden="true" onClick={openBillingModal}></i> : <i className="fa fa-usd" aria-hidden="true"></i> } &nbsp;
                                { item.actions.meritocracia  ? <i className="fa fa-trophy table-color-button" aria-hidden="true" onClick={openMeritocracyModal}></i> : <i className="fa fa-trophy" aria-hidden="true"></i> } &nbsp;
                                { item.actions.revisar  ? <i className="fa fa-search table-color-button" aria-hidden="true" onClick={openReviewModal}></i> : <i className="fa fa-search" aria-hidden="true"></i> } &nbsp; */}
                    </div>
                })
            })
            return valoresAtividadesAttr;
        }

        return [];

    };

    const sortees = React.useMemo(
        () => [
            {
                id: "data",
                asc: true
            },
        ],
        []
    );

    const {
        getTableProps, // table props from react-table
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        rows, // rows for the table based on the data passed
        prepareRow // Prepare the row (this function needs to be called for each row before getting the row props)
    } = useTable({
        columns,

        data: atividades,
        initialState: {
            sortBy: sortees
        }
    }, useSortBy);

    useEffect(() => {
        const timesheetAtividadesTable = getAtividadesList(timesheetAtividades)
        setAtividades(timesheetAtividadesTable);
    }, [timesheetAtividades]);

    const corLinha = (row) => {
        var className = ""
        switch(row.values.status) {
            case 'Notificado':
                className = 'table-data-info-warning'
                break;
            case 'Cancelado':
                className = 'table-data-info-canceled'
                break;
            default:
                if(row.original.proBono)
                    className = 'table-data-info-pro-bono'
                else
                    className = 'table-data-info'            
        }

        return className;
    }

    return (
        <StyledTablePage >
            <div>
                <table {...getTableProps()} className="table table-bordered table-width">
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id} className="text-center">
                                {headerGroup.headers.map((column) => {
                                    return column.hideHeader === false ? null : (
                                        <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                            {column.render("Header")}
                                            <span style={{ marginLeft: '3px' }}>
                                                {
                                                    column.isSorted
                                                        ? column.isSortedDesc
                                                            ? <svg width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" /></svg>
                                                            : <svg width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z" /></svg>
                                                        : null
                                                }
                                            </span>
                                        </th>);
                                }
                                )}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map((row, i) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}
                                    className={corLinha(row)}
                                >
                                    {row.cells.map(cell => {
                                        return (
                                            <td {...cell.getCellProps()}>
                                                <span>
                                                {
                                                    cell.column.id === 'status'
                                                    ? (<span className={row.values.status === 'Editado' ? 'data-info-sublinhado' : ''}>&nbsp;&nbsp;{cell.render("Cell")}&nbsp;&nbsp;</span>)
                                                    : (<span>{cell.render("Cell")}</span>)
                                                }
                                                </span>
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </StyledTablePage>
    )
};
